/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Inbound_Waiting_On_Tomorrow_CheckInputs */

const en_inbound_waiting_on_tomorrow_check = /** @type {(inputs: Inbound_Waiting_On_Tomorrow_CheckInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on Tomorrow · three-way check · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on Tomorrow · three-way check · since {since}" |
*
* @param {Inbound_Waiting_On_Tomorrow_CheckInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_waiting_on_tomorrow_check = /** @type {((inputs: Inbound_Waiting_On_Tomorrow_CheckInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Waiting_On_Tomorrow_CheckInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_waiting_on_tomorrow_check(inputs)
});